import {SuperAlign} from "./segments/SuperAlign";
import './segments/two_columns-subitems';

const superAlign = new SuperAlign('.js-text-normalize');
superAlign.init();
